import { Conference } from '../types';

export const conferencesData: Conference[] = [
  {
    id: "developerweek-2022",
    name: "DeveloperWeek 2022",
    year: "2022",
    location: "Austin, TX",
    role: "Speaker",
    description: "Led a tech talk for Intuit about ICE (In-App Push) and published an Intuit engineering blog on Building Real Time Interactive Experiences Using In-App Push at Intuit.",
    link: "https://www.developerweek.com/"
  },
  {
    id: "splunk-conf-2018",
    name: "Splunk .conf18",
    year: "2018",
    location: "Orlando, FL",
    role: "Speaker",
    description: "Presented on search platform services and large scale search processing at Splunk's annual conference.",
    link: "https://conf.splunk.com/"
  },
  {
    id: "splunk-conf-2019",
    name: "Splunk .conf19",
    year: "2019",
    location: "Las Vegas, NV",
    role: "Search Tech Booth Leader",
    description: "Led the Search Technology booth and presented on search platform innovations and capabilities.",
    link: "https://conf.splunk.com/"
  },
  {
    id: "nvidia-gtc-2014",
    name: "NVIDIA GPU Technology Conference",
    year: "2014",
    location: "San Jose, CA",
    role: "Attendee",
    description: "Attended sessions on GPU computing, AI, and deep learning advancements.",
    link: "https://www.nvidia.com/gtc/"
  },
  {
    id: "nips-2014",
    name: "Neural Information Processing Systems (NIPS)",
    year: "2014",
    location: "Montreal, Canada",
    role: "Attendee",
    description: "Attended international conference on machine learning and computational neuroscience.",
    link: "https://nips.cc/Conferences/2014"
  },
  {
    id: "tc-disrupt-2016",
    name: "TechCrunch Disrupt",
    year: "2016",
    location: "San Francisco, CA",
    role: "Attendee",
    description: "Attended TechCrunch Disrupt, a leading technology startup conference.",
    link: "https://techcrunch.com/events/disrupt-sf-2016/"
  },
  {
    id: "tc-disrupt-2014-2015",
    name: "TechCrunch Disrupt",
    year: "2014-2015",
    location: "San Francisco, CA",
    role: "Attendee",
    description: "Attended TechCrunch Disrupt, a leading technology startup conference, in consecutive years.",
    link: "https://techcrunch.com/events/disrupt-sf-2015/"
  }
]; 